export function downloadXML(byteArrayStr: string, fileName: string) {
  var csvStr = atob(byteArrayStr);
  var hiddenElement = document.createElement("a");
  hiddenElement.href = "data:application/xml;charset=utf-8," + encodeURI(csvStr);
  hiddenElement.target = "_blank";
  hiddenElement.download = `${fileName}`;
  hiddenElement.click();
}
